import { RAYGUN_PROD, RAYGUN_UAT } from '../config';

export const getErrorMessage = (error: Error): string => {
  if (!error.stack) {
    return error.message || error.toString();
  }
  return error.stack;
};

export const isRaygunEnabled = (): string | false => {
  // only for UAT and Production
  if (window.location.host.includes('uat')) {
    return RAYGUN_UAT;
  }

  if (window.location.host.includes('tertius.dcra.dc.gov')) {
    return RAYGUN_PROD;
  }

  return false;
};
